export default {
  default: {
    title: 'Levis - $metaDescription',
    description: '$metaDescription',
    keywords: 'levis',
  },
};
